import { cn, useMediaQuery } from "@kyan/ui";
import { useRef } from "react";

import {
  NumericInputWithSelect,
  type NumericInputWithSelectProps,
} from "#/components/NumericInputWithSelect/NumericInputWithSelect";
import { useOption } from "#/store/options/tradePanel/option";
import { usePerpIsBuy } from "#/store/perps/tradePanel/perpIsBuy";
import { usePerpLimitPrice } from "#/store/perps/tradePanel/perpLimitPrice";

export const FocusableSizeInput = ({
  inputProps,
  selectProps,
}: NumericInputWithSelectProps<string>) => {
  const { option } = useOption();
  const { isSm } = useMediaQuery();
  const { updateTime } = usePerpLimitPrice();
  const { perpIsBuy } = usePerpIsBuy();
  const autoFocusDepsRef = useRef([
    option?.instrument_name,
    option?.isBuy,
    updateTime,
    perpIsBuy,
  ]);

  if (inputProps.value === "") {
    // eslint-disable-next-line react-hooks/refs -- intentional: ref is updated during render to track dep changes for auto-focus triggering
    autoFocusDepsRef.current = [
      option?.instrument_name,
      option?.isBuy,
      updateTime,
      perpIsBuy,
    ];
  }

  return (
    <NumericInputWithSelect
      selectProps={selectProps}
      inputProps={{
        ...inputProps,
        className: cn("w-full", inputProps.className),
        wrapperClassName: cn("h-11 sm:h-8", inputProps.wrapperClassName),
        // eslint-disable-next-line react-hooks/refs -- intentional: ref value is read during render to pass as auto-focus deps
        autoFocus: isSm ? autoFocusDepsRef.current : undefined,
      }}
    />
  );
};
